export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/light-bulb-confetti.1be8d096.svg","height":44,"width":43};